if (!customElements.get('jc-filter-drawer')) {
  customElements.define(
    'jc-filter-drawer',
    class JCFilterDrawer extends ModalDialog {
      connectedCallback() {
        super.connectedCallback();
        this.querySelector('.jc-filter-drawer__apply')?.addEventListener('click', () => this.hide());
      }
    }
  );
}
